import { CardContent } from "@mui/material";
import Card, { type CardProps } from "@mui/material/Card";
import { MuiImageBackground, useIsDesktop } from '@repo/ui';
import { type FC, PropsWithChildren } from "react";

export interface OverviewBaseProps extends CardProps {
	image?: string;
	alt?: string;
	opacity?: boolean;
}

export const OverviewBase: FC<OverviewBaseProps> = ({
	alt,
	image,
	children,
	sx,
	opacity,
	...rest
}) => {
	return (<Card
		{...rest}
		sx={{
			overflow: "visible",
			px: 4,
			boxShadow: "none",
			...sx,
		}}
	>
		{image && <MuiImageBackground
			sx={{
				paddingBottom: { md: 0, xs: "50%" },
				backgroundPosition: "50% 0",
				backgroundSize: "cover",
				opacity: opacity ? 0.5 : 1,
			}}
			src={image}
		/>}
		{children}
	</Card>)
};

export const Overview: FC<OverviewBaseProps> = ({ alt, image, children, sx, ...rest }) => {
	const isD = useIsDesktop();
	return (
		<OverviewBase alt={alt} image={image} sx={sx} {...rest}>
			{children && (
				<CardContent
					sx={{
						mb: isD ? 0 : 3,
						py: 5,
						px: 4,
						boxShadow: "far",
					}}
				>
					{children}
				</CardContent>
			)}
		</OverviewBase>
	);
}

export const OverviewLoginType: FC<PropsWithChildren<{
	alt: string;
	opacity?: boolean;
	image: string
}>> = ({
	children,
	alt,
	opacity,
	image
}) => {
		return (
			<Overview
				image={image}
				alt={alt}
				sx={{
					overflow: { md: "visible", xs: "hidden" },
					mb: { md: 0, xs: -4 },
					mx: { md: 0, xs: -4 },
					p: { md: 0 },
					pt: { md: "0px" },
					".MuiCardContent-root": {
						boxShadow: "close",
					},
					".MuiCardMedia-root": {
						display: { md: "none" },
					},
				}}
				opacity={opacity}
			>
				{children}
			</Overview>
		);
	}

